export default __webpack_public_path__ + "static/hashmasks-3b8cd8dbf2caf46e7be5c54a4fd493c2.png";